import { ComponentProps } from 'react';
import clsx from 'clsx';
import { Transfer } from 'antd';

import './OpTransfer.scss';

interface IOpTransferProps extends ComponentProps<typeof Transfer> {
  testId?: string;
}

export const OpTransfer = ({
  className,
  testId = 'op-transfer',
  ...elementProps
}: IOpTransferProps) => {
  return (
    // Currently antd isnt supporting data-testid being directly added to the component
    <div data-testid={testId}>
      <Transfer className={clsx('op-transfer', className)} {...elementProps} />
    </div>
  );
};
